/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LicensePlate } from './licensePlate';

/**
 * Various data related to a vehicle license plate.   (bipro-fahrzeug::Kennzeichen)
 */
export interface LicensePlateData {
  licensePlate?: LicensePlate;
  /**
   * In case of true, this is a season plate with month range.   (german: Saison Kennzeichen)
   */
  isSeasonPlate?: boolean;
  /**
   * In case of season plate, this is the begin month.
   */
  seasonPlateBeginMonth?: number;
  /**
   * In case of season plate, this is the end month.
   */
  seasonPlateEndMonth?: number;
}
